<template>

    <div class="typeform-popin">
        <iframe width="100%" height="100%" src="https://verspieren.typeform.com/to/P0QMhb?source=feedbackbutton" frameborder="0"></iframe>
    </div>

</template>

<script>

    import URI from 'urijs'
    import $ from 'jquery'
    
    export default {
      name: "TypeFormPopin",
    };
</script>

<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .typeform-popin
        +media("<=600px")
            height: calc(100% - 32px)
        iframe
            width: 100%
            height: 450px
            +media("<=600px")
                height: 100%


</style>
